import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfTablolarDetay = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfTablolarDetayData: {
          SiraNo: 0,
            Gostergesi: "",
            FormulIcerik: "",
            DetayVar: false,
            Formul: "",
            Aktif: false,     
            BaskaBirimlerGorsun: false,
            Renk: "",
            DetaydanHesaplamasin: false,
            HedefDonemlerindeKapali: false,
            HedefEtkisi: 0,
            Aciklama: "",
            TabloId: null,
            GostergeTipiId: null,
            OlcuBirimiId: null,
            GostergeYonuId: null,
            OlcumHesaplamaTuruId: null,
            SorguId: null,
            OlcumPeriyodu: null,
            RaporlamaSikligi: null,
            GostergeTuruId: null,
            Id: null,
            KanitGerekli: false,
            Formulduzey:0,
            Deleted: false,
            PasifeAlinmaTarihi: null,
            RaporlardaGozukmesin: false,
            OlusturulmaTarihi: null,
            AvesisId:null
          },

        FormDataType:{ 
            TabloId:{FieldName:"TabloId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.TabloId'),Disabled:"disabled",ComboDataArray:[]},
            GostergeTipiId:{FieldName:"GostergeTipiId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.GostergeTipiId'),ComboDataArray:[]},
            SiraNo:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.SiraNo'),FieldType:"number"},
            HedefEtkisi:{FieldName:"HedefEtkisi",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.HedefEtkisi'),FieldType:"number"},       
            Gostergesi:{FieldName:"Gostergesi",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Gostergesi'),FieldType:"text"},
            Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Aciklama'),FieldType:"text"},
            Aktif:{FieldName:"Aktif",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Aktif')},
            KanitGerekli:{FieldName:"KanitGerekli",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.KanitGerekli')},
            OlcumPeriyodu:{FieldName:"OlcumPeriyodu",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.OlcumPeriyodu'),ComboDataArray:[]},
            RaporlamaSikligi:{FieldName:"RaporlamaSikligi",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.RaporlamaSikligi'),ComboDataArray:[]},
            OlcuBirimiId:{FieldName:"OlcuBirimiId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.OlcuBirimiId'),ComboDataArray:[]},
            GostergeTuruId:{FieldName:"GostergeTuruId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.GostergeTuruId'),ComboDataArray:[]},
            GostergeYonuId:{FieldName:"GostergeYonuId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.SiraNo'),ComboDataArray:[]},
            OlcumHesaplamaTuruId:{FieldName:"OlcumHesaplamaTuruId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.OlcumHesaplamaTuruId'),ComboDataArray:[]},
            SorguId:{FieldName:"SorguId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.SorguId'),ComboDataArray:[]},
            DetayVar:{FieldName:"DetayVar",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.DetayVar')},
            DetaydanHesaplamasin:{FieldName:"DetaydanHesaplamasin",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.DetaydanHesaplamasin')},
            BaskaBirimlerGorsun:{FieldName:"BaskaBirimlerGorsun",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.BaskaBirimlerGorsun')},
            FormulIcerik:{FieldName:"FormulIcerik",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.FormulIcerik'),FieldType:"text"},
            Formul:{FieldName:"Formul",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Formul'),ComboDataArray:[]},
            Renk:{FieldName:"Renk",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Renk'),ComboDataArray:[]},
            HedefDonemlerindeKapali:{FieldName:"HedefDonemlerindeKapali",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.HedefDonemlerindeKapali')},
            Formulduzey:{FieldName:"Formulduzey",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.Formulduzey'),ComboDataArray:[]},
            PasifeAlinmaTarihi:{FieldName:"PasifeAlinmaTarihi",Field:"input",FieldTitle: this.$t('StrPerfTablolarDetay.AddEdit.PasifeAlinmaTarihi'),FieldType:"date"},
            RaporlardaGozukmesin:{FieldName:"RaporlardaGozukmesin",Field:"checkbox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.RaporlardaGozukmesin')},
            OlusturulmaTarihi:{FieldName:"OlusturulmaTarihi",Field:"input",FieldTitle: this.$t('StrPerfTablolarDetay.AddEdit.OlusturulmaTarihi'),FieldType:"date"},
            AvesisId:{FieldName:"AvesisId",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetay.AddEdit.AvesisId'),ComboDataArray:[]},
           
        } ,
        Renkler: [
          { Id:"0",  Value:"Seçiniz" },
          { Id:"Transparent",  Value:"Transparent" },
          { Id:"AliceBlue",  Value:"AliceBlue" },
          { Id:"AntiqueWhite",  Value:"AntiqueWhite" },
          { Id:"Aqua",  Value:"Aqua" },
          { Id:"Aquamarine",  Value:"Aquamarine" },
          { Id:"Azure",  Value:"Azure" },
          { Id:"Beige",  Value:"Beige" },
          { Id:"Bisque",  Value:"Bisque" },
          { Id:"Black",  Value:"Black" },
          { Id:"BlanchedAlmond",  Value:"BlanchedAlmond" },
          { Id:"Blue",  Value:"Blue" },
          { Id:"BlueViolet",  Value:"BlueViolet" },
          { Id:"Brown",  Value:"Brown" },
          { Id:"BurlyWood",  Value:"BurlyWood" },
          { Id:"CadetBlue",  Value:"CadetBlue" },
          { Id:"Chartreuse",  Value:"Chartreuse" },
          { Id:"Chocolate",  Value:"Chocolate" },
          { Id:"Coral",  Value:"Coral" },
          { Id:"CornflowerBlue",  Value:"CornflowerBlue" },
          { Id:"Cornsilk",  Value:"Cornsilk" },
          { Id:"Crimson",  Value:"Crimson" },
          { Id:"Cyan",  Value:"Cyan" },
          { Id:"DarkBlue",  Value:"DarkBlue" },
          { Id:"DarkCyan",  Value:"DarkCyan" },
          { Id:"DarkGoldenrod",  Value:"DarkGoldenrod" },
          { Id:"DarkGray",  Value:"DarkGray" },
          { Id:"DarkGreen",  Value:"DarkGreen" },
          { Id:"DarkKhaki",  Value:"DarkKhaki" },
          { Id:"DarkMagenta",  Value:"DarkMagenta" },
          { Id:"DarkOliveGreen",  Value:"DarkOliveGreen" },
          { Id:"DarkOrange",  Value:"DarkOrange" },
          { Id:"DarkOrchid",  Value:"DarkOrchid" },
          { Id:"DarkRed",  Value:"DarkRed" },
          { Id:"DarkSalmon",  Value:"DarkSalmon" },
          { Id:"DarkSeaGreen",  Value:"DarkSeaGreen" },
          { Id:"DarkSlateBlue",  Value:"DarkSlateBlue" },
          { Id:"DarkSlateGray",  Value:"DarkSlateGray" },
          { Id:"DarkTurquoise",  Value:"DarkTurquoise" },
          { Id:"DarkViolet",  Value:"DarkViolet" },
          { Id:"DeepPink",  Value:"DeepPink" },
          { Id:"DeepSkyBlue",  Value:"DeepSkyBlue" },
          { Id:"DimGray",  Value:"DimGray" },
          { Id:"DodgerBlue",  Value:"DodgerBlue" },
          { Id:"Firebrick",  Value:"Firebrick" },
          { Id:"FloralWhite",  Value:"FloralWhite" },
          { Id:"ForestGreen",  Value:"ForestGreen" },
          { Id:"Fuchsia",  Value:"Fuchsia" },
          { Id:"Gainsboro",  Value:"Gainsboro" },
          { Id:"GhostWhite",  Value:"GhostWhite" },
          { Id:"Gold",  Value:"Gold" },
          { Id:"Goldenrod",  Value:"Goldenrod" },
          { Id:"Gray",  Value:"Gray" },
          { Id:"Green",  Value:"Green" },
          { Id:"GreenYellow",  Value:"GreenYellow" },
          { Id:"Honeydew",  Value:"Honeydew" },
          { Id:"HotPink",  Value:"HotPink" },
          { Id:"IndianRed",  Value:"IndianRed" },
          { Id:"Indigo",  Value:"Indigo" },
          { Id:"Ivory",  Value:"Ivory" },
          { Id:"Khaki",  Value:"Khaki" },
          { Id:"Lavender",  Value:"Lavender" },
          { Id:"LavenderBlush",  Value:"LavenderBlush" },
          { Id:"LawnGreen",  Value:"LawnGreen" },
          { Id:"LemonChiffon",  Value:"LemonChiffon" },
          { Id:"LightBlue",  Value:"LightBlue" },
          { Id:"LightCoral",  Value:"LightCoral" },
          { Id:"LightCyan",  Value:"LightCyan" },
          { Id:"LightGoldenrodYellow",  Value:"LightGoldenrodYellow" },
          { Id:"LightGreen",  Value:"LightGreen" },
          { Id:"LightGray",  Value:"LightGray" },
          { Id:"LightPink",  Value:"LightPink" },
          { Id:"LightSalmon",  Value:"LightSalmon" },
          { Id:"LightSeaGreen",  Value:"LightSeaGreen" },
          { Id:"LightSkyBlue",  Value:"LightSkyBlue" },
          { Id:"LightSlateGray",  Value:"LightSlateGray" },
          { Id:"LightSteelBlue",  Value:"LightSteelBlue" },
          { Id:"LightYellow",  Value:"LightYellow" },
          { Id:"Lime",  Value:"Lime" },
          { Id:"LimeGreen",  Value:"LimeGreen" },
          { Id:"Linen",  Value:"Linen" },
          { Id:"Magenta",  Value:"Magenta" },
          { Id:"Maroon",  Value:"Maroon" },
          { Id:"MediumAquamarine",  Value:"MediumAquamarine" },
          { Id:"MediumBlue",  Value:"MediumBlue" },
          { Id:"MediumOrchid",  Value:"MediumOrchid" },
          { Id:"MediumPurple",  Value:"MediumPurple" },
          { Id:"MediumSeaGreen",  Value:"MediumSeaGreen" },
          { Id:"MediumSlateBlue",  Value:"MediumSlateBlue" },
          { Id:"MediumSpringGreen",  Value:"MediumSpringGreen" },
          { Id:"MediumTurquoise",  Value:"MediumTurquoise" },
          { Id:"MediumVioletRed",  Value:"MediumVioletRed" },
          { Id:"MidnightBlue",  Value:"MidnightBlue" },
          { Id:"MintCream",  Value:"MintCream" },
          { Id:"MistyRose",  Value:"MistyRose" },
          { Id:"Moccasin",  Value:"Moccasin" },
          { Id:"NavajoWhite",  Value:"NavajoWhite" },
          { Id:"Navy",  Value:"Navy" },
          { Id:"OldLace",  Value:"OldLace" },
          { Id:"Olive",  Value:"Olive" },
          { Id:"OliveDrab",  Value:"OliveDrab" },
          { Id:"Orange",  Value:"Orange" },
          { Id:"OrangeRed",  Value:"OrangeRed" },
          { Id:"Orchid",  Value:"Orchid" },
          { Id:"PaleGoldenrod",  Value:"PaleGoldenrod" },
          { Id:"PaleGreen",  Value:"PaleGreen" },
          { Id:"PaleTurquoise",  Value:"PaleTurquoise" },
          { Id:"PaleVioletRed",  Value:"PaleVioletRed" },
          { Id:"PapayaWhip",  Value:"PapayaWhip" },
          { Id:"PeachPuff",  Value:"PeachPuff" },
          { Id:"Peru",  Value:"Peru" },
          { Id:"Pink",  Value:"Pink" },
          { Id:"Plum",  Value:"Plum" },
          { Id:"PowderBlue",  Value:"PowderBlue" },
          { Id:"Purple",  Value:"Purple" },
          { Id:"Red",  Value:"Red" },
          { Id:"RosyBrown",  Value:"RosyBrown" },
          { Id:"RoyalBlue",  Value:"RoyalBlue" },
          { Id:"SaddleBrown",  Value:"SaddleBrown" },
          { Id:"Salmon",  Value:"Salmon" },
          { Id:"SandyBrown",  Value:"SandyBrown" },
          { Id:"SeaGreen",  Value:"SeaGreen" },
          { Id:"SeaShell",  Value:"SeaShell" },
          { Id:"Sienna",  Value:"Sienna" },
          { Id:"Silver",  Value:"Silver" },
          { Id:"SkyBlue",  Value:"SkyBlue" },
          { Id:"SlateBlue",  Value:"SlateBlue" },
          { Id:"SlateGray",  Value:"SlateGray" },
          { Id:"Snow",  Value:"Snow" },
          { Id:"SpringGreen",  Value:"SpringGreen" },
          { Id:"SteelBlue",  Value:"SteelBlue" },
          { Id:"Tan",  Value:"Tan" },
          { Id:"Teal",  Value:"Teal" },
          { Id:"Thistle",  Value:"Thistle" },
          { Id:"Tomato",  Value:"Tomato" },
          { Id:"Turquoise",  Value:"Turquoise" },
          { Id:"Violet",  Value:"Violet" },
          { Id:"Wheat",  Value:"Wheat" },
          { Id:"White",  Value:"White" },
          { Id:"WhiteSmoke",  Value:"WhiteSmoke" },
          { Id:"Yellow",  Value:"Yellow" },
          { Id:"YellowGreen",  Value:"YellowGreen" },
        ],  
        Formulduzeyleri: [
          { Id:"1",  Value:"Birim Düzeyinde Hesaplama" },
          { Id:"2",  Value:"Kurum Düzeyinde Hesaplama" },
          
        ], 
      }
    },
    validations:{ 
        FormData: {
          TabloId: { required },
            SiraNo: { required, numeric },
            Gostergesi: { required },
            FormulIcerik: {},        
            Renk: { },
            HedefEtkisi: { required },
            Aciklama: {},           
            GostergeTipiId: { required },
            OlcuBirimiId: {},
            GostergeYonuId: {},
            OlcumHesaplamaTuruId: {},
            SorguId: {},
            OlcumPeriyodu: {},
            RaporlamaSikligi: {},
            GostergeTuruId: {},
            Aktif: {},
            KanitGerekli: {},
            DetayVar: {},
            DetaydanHesaplamasin: {},
            BaskaBirimlerGorsun: {},
            HedefDonemlerindeKapali: {},
            Formulduzey:{},
            PasifeAlinmaTarihi: {},
            RaporlardaGozukmesin: {},
            OlusturulmaTarihi: {},
            AvesisId: {}
        } 
    },

   created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999",
      }
        /*
            this.FormDataType.TabloId.ComboDataArray=[];
            this.ActionsGet({"Service":"StrPerfTablo", "Page":Page}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.TabloId.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adi})
                }
            });
      */
             
            let Filter = "&Tip=47";
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.GostergeTipiId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})   
                }
               
            });

            Filter = "&Tip=1556";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.OlcumPeriyodu.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

            Filter = "&Tip=89";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.OlcuBirimiId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

            Filter = "&Tip=204";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.OlcumHesaplamaTuruId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

            Filter = "&Tip=202";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.GostergeTuruId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

            Filter = "&Tip=203";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.GostergeYonuId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

            Filter = "&Tip=1556";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.RaporlamaSikligi.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

             Filter = "&Tip=1600";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.AvesisId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });

           

            this.ActionsGet({"Service":"StrSorgular", "Page":Page}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.SorguId.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Sorguadi})
                    this.FormDataType.Formul.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Sorgu})
                }
            });

            this.FormDataType.Renk.ComboDataArray=[];
            for(var i=0; i<this.Renkler.length; i++)
            {
                this.FormDataType.Renk.ComboDataArray.push ({Id:this.Renkler[i].Id,Value:this.Renkler[i].Value})
          
            }
            this.FormDataType.Formulduzey.ComboDataArray=[];
            for(i=0; i<this.Formulduzeyleri.length; i++)
            {
                this.FormDataType.Formulduzey.ComboDataArray.push ({Id:this.Formulduzeyleri[i].Id,Value:this.Formulduzeyleri[i].Value})
          
            }

        

      
    }

}
export default StrPerfTablolarDetay